// Generated by CoffeeScript 2.7.0
var ResponsesTable;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newResponseModal
} from 'trunks/vue/admin/compositions/response_modal.js';

import DataTableMixin from 'trunks/vue/admin/compositions/datable_table/mixin.js';

import {
  addResponseSpecialFields
} from 'trunks/vue/admin/compositions/datable_table/table_special_fields.js';

import DataclipFormModal from 'trunks/vue/admin/compositions/dataclip/form_modal.js';

import ResponsesSearchSettingModal from 'trunks/vue/admin/compositions/responses_data_search/responses_search_modal.js';

import ImportRecordsModal from 'trunks/vue/admin/compositions/dataclip/import_records_modal.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

export default ResponsesTable = Vue.extend({
  mixins: [DataTableMixin],
  components: {
    'group-options': GroupOptions
  },
  template: `<div class="datable-table-wrapper">
  <div class="filter-summary justify-box" v-if='filtersExist'>
    <span>筛选条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, filter_key) in filters'
                   :key='filter_key'
                   :filter='filter'
                   @remove='removeFilter' />
    </div>
  </div>
  <div class="datable-table-summary justify-between">
    <div class='vertical-middle'>
      <span>共 {{ totalCount }} 条记录</span>
      <span v-if='!_.isBlank(composedPreservedFilters)' class='btn btn-small btn-default outlined perserved-filters-toggler' @click='togglePreserveredFiltersFunc'>视图条件</span>
    </div>
    <div class="actions">
      <popover position='bottom center' ref='batchRemoveResponsePopover' customClass='action-item' size='small' :disabled='!hasRecords' type='select'>
        <template slot='trigger'>
          <div
            class="btn text-btn btn-default action-item"
          >
            <i class='slp-trash'></i>
            <span>删除</span>
          </div>
        </template>
        <template slot='content'>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordDeleteOptions}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='deleteRecordOptionsRef'>
                <template slot='option-item-template' slot-scope='{ option }'>
                  <div v-if="option.id === 'filtered' " class="content">{{ \`\${option.value}（\${selectedRows.length}条）\` }}</div>
                  <div v-else class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeBatchRemoveResponsePopover'>取消</div>
              <div class='btn text-btn' @click.stop='batchRemoveResponse'>确认</div>
            </div>
          </div>
        </template>
      </popover>
      <div class="btn text-btn btn-default action-item" @click="saveToDataclipFunc">
        <i class='slp-view-save'></i>
        <span>保存为视图</span>
      </div>
      <div class="btn text-btn btn-default action-item" @click="openResponseSearchSettingModal">
        <i class='slp-text-search-o'></i>
        <span>数据搜索设置</span>
      </div>
      <popover position='bottom center'
               type='select'
               size='normal'
               :stopPropagation='true'
               ref='filterPopover'
               customClass='action-item field-filter-popover'>
        <template slot='trigger'>
          <div class="btn text-btn btn-default action-item">
            <i class="slp-toggle"></i>
            <span>显示字段</span>
          </div>
        </template>
        <template slot='content'>
          <div class="popover-select-content">
            <div class='popover-select-header'>
              <div class='justify-between'>
                <span class='gray-text'>显示字段</span>
                <div class='content'>
                  <span v-show='!fieldsAllSelected' class='btn text-btn btn-default' @click='invertSelectFieldsFunc'>反选</span>
                  <i :class="{ 'slp-check': fieldsAllSelected, 'slp-empty': !fieldsAllSelected }"></i>
                  <span class='btn text-btn btn-default' @click='selectAllFieldsFunc'>全选</span>
                </div>
              </div>
            </div>
            <div class="popover-select-body">
              <div class='list'>
                <div class="list-item"
                    v-for='field in fields'
                    @click='toggleHideField(field)'
                    :key='field.id'>
                  <div class="content text-ellipsis">{{ field.title }}</div>
                  <i class="slp-empty" v-if='field._hidden'></i>
                  <i class="slp-check" v-else></i>
                </div>
              </div>
            </div>
          </div>
        </template>
      </popover>
      <div class="btn link-btn btn-default" @click="openResponseImportModal">
        <i class="slp-upload-o"></i>
        <span>导入</span>
      </div>
      <popover position='bottom center' ref='exportPopover' customClass='action-item export-popover' size='small' :disabled='!hasRecords' type='select'>
        <template slot='trigger'>
          <div class="btn text-btn btn-default" :class="{ disabled: !hasRecords }">
            <i class="slp-download-o"></i>
            <span>导出</span>
          </div>
        </template>
        <template slot='content'>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordExportOptions}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='recordGroupedOptionsRef'>
                <template slot='option-item-template' slot-scope='{ option }'>
                  <div class="content">{{ option.value }}({{ option.id == 'all' ? totalRecordCount : totalCount }}条)</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
              <group-options v-show="!fieldsAllSelected"
                             :groupedOptions='[{options: exportOptions.field}]'
                             :multiple='false'
                             @valueChanged='exportOptionValueChangedFunc'
                             ref='fieldGroupedOptionsRef'>
                <template slot='option-item-template' slot-scope='{ option }'>
                  <div class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeExportPopover'>取消</div>
              <div class='btn text-btn' @click.stop='ensureExport'>导出</div>
            </div>
          </div>
        </template>
      </popover>
      <popover position='bottom center' ref='downloadAttachmentPopover' customClass='action-item' size='default' :disabled='!hasRecords' type='select'>
        <template slot='trigger'>
          <div class="btn text-btn btn-default" :class="{ disabled: !hasRecords }">
            <i class="slp-attachment"></i>
            <span>下载附件</span>
          </div>
        </template>
        <template slot='content'>
          <div class="popover-select-content">
            <div class="popover-select-body">
              <group-options :groupedOptions='[{options: recordDownloadAttachmentOptions}]'
                             :multiple='false'
                             @valueChanged='downloadAttachmentOptionValueChangedFunc'
                             ref='recordDownloadAttachmentGroupedOptionsRef'>
                <template slot='option-item-template' slot-scope='{ option }'>
                  <div class="content">{{ option.value }}</div>
                  <div class="tip icon">
                    <i :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
                  </div>
                </template>
              </group-options>
            </div>
            <div class="popover-select-footer">
              <div class='btn text-btn' @click.stop='closeDownloadAttachmentPopover'>取消</div>
              <div class='btn text-btn' @click.stop='ensureDownloadAttachment'>下载</div>
            </div>
          </div>
        </template>
      </popover>
      <a class="btn text-btn btn-default action-item" data-remote="true" href="/exportable_files">
        <i class="slp-download-list"></i>
        <span>下载列表</span>
      </a>
      <button class="action-item" @click='addNewResponse'>
        <i class="slp-plus"></i>
        <span>添加</span>
      </button>
    </div>
  </div>
  <div class="preserved-filter-summary justify-box" v-if='!_.isBlank(composedPreservedFilters)' v-show='preserveredFiltersShown'>
    <span>视图条件</span>
    <div class="params chips content">
      <filter-chip v-for='(filter, filter_key) in composedPreservedFilters'
                   :key='filter_key'
                   :filter='filter'
                   :removable='false' />
    </div>
  </div>
  <v-table :headers='filterFields'
           :rows='recordRows'
           :fixedColumnIds='fixedColumnIds'
           @rowClicked='displayResponseIfNeed'
           @selectedRowsChanged='selectedRowsChangedFunc'
           ref='bodyTable'>
    <template slot='header' slot-scope='{ header }'>
      <header-cell :field='header'
                   :filter='_getFilterByField(header)'
                   :order='order'
                   @filterChanged='removeOrUpdateFilter'
                   @orderChanged='removeOrUpdateOrder' />
    </template>
    <template slot='body' slot-scope='{ cell }'>
      <field-cell :field='cell.field'
                  :entries='cell.entries'
                  @cellItemClicked='displayItemIfNeed'></field-cell>
    </template>
  </v-table>
  <paginator :resourceUrl="paginatorUrl"
             ref='paginator'
             :additionalParams='paginatorParams'
             :beforeRequestFunc='beforeRecordsRequestFunc'
             :afterRequestFunc='afterRecordsRequestFunc'
             @dataReceived='updateRecords' />
</div>`,
  data: function() {
    return {
      fixedColumnIds: [-2],
      exportOptions: {
        record: [
          {
            id: 'all',
            value: '全部纪录'
          },
          {
            id: 'filtered',
            value: '筛选纪录'
          }
        ],
        field: [
          {
            id: 'all',
            value: '全部字段'
          },
          {
            id: 'filtered',
            value: '显示字段'
          }
        ]
      },
      downloadAttachmentOptions: [
        {
          id: 'all',
          value: '全部记录附件'
        },
        {
          id: 'filtered',
          value: '选中记录附件'
        }
      ],
      deleteOptions: [
        {
          id: 'all',
          value: '删除所有记录'
        },
        {
          id: 'filtered',
          value: '删除记录'
        }
      ],
      selectedRows: []
    };
  },
  created: function() {
    return this._initDefaultExportOption();
  },
  computed: {
    paginatorUrl: function() {
      if (this.filtersExist || this.order.value) {
        return `${this.datableUrl}/responses/search.json`;
      } else {
        return this.resourceUrl;
      }
    },
    datableUrl: function() {
      return Skylark.Helpers.UrlHelper.adminUrlFor(this.datableGID.toPath());
    },
    resourceUrl: function() {
      return `${this.datableUrl}/responses.json`;
    },
    hasQuerySearchParams: function() {
      return Boolean(this.searchParams.query && !(_.isBlank(this.searchParams.query)));
    },
    recordExportOptions: function() {
      if (this.hasQuerySearchParams) {
        return this.exportOptions.record;
      } else {
        return [this.exportOptions.record[0]];
      }
    },
    recordDownloadAttachmentOptions: function() {
      var all_option, filter_option;
      all_option = this.downloadAttachmentOptions[0];
      filter_option = this.downloadAttachmentOptions[1];
      if (this.selectedRows.length > 0) {
        Vue.set(all_option, '_selected', false);
        Vue.set(filter_option, '_selected', true);
        return this.downloadAttachmentOptions;
      } else {
        Vue.set(all_option, '_selected', true);
        return [all_option];
      }
    },
    recordDeleteOptions: function() {
      var all_option, filter_option;
      all_option = this.deleteOptions[0];
      filter_option = this.deleteOptions[1];
      if (this.selectedRows.length > 0) {
        Vue.set(all_option, '_selected', false);
        Vue.set(filter_option, '_selected', true);
      } else {
        Vue.set(all_option, '_selected', true);
        Vue.set(filter_option, '_selected', false);
      }
      return this.deleteOptions;
    }
  },
  watch: {
    recordExportOptions: function(new_value) {
      var all_option, filter_option;
      all_option = this.exportOptions.record[0];
      filter_option = this.exportOptions.record[1];
      if (this.hasQuerySearchParams) {
        all_option._selected = false;
        return filter_option._selected = true;
      } else {
        all_option._selected = true;
        return filter_option._selected = false;
      }
    }
  },
  methods: {
    _initDefaultExportOption: function() {
      return _.each(this.exportOptions, function(option_group, type) {
        var all_option, filter_option;
        all_option = option_group[0];
        filter_option = option_group[1];
        if (type === 'record') {
          Vue.set(all_option, '_selected', true);
          return Vue.set(filter_option, '_selected', false);
        } else {
          Vue.set(all_option, '_selected', false);
          return Vue.set(filter_option, '_selected', true);
        }
      });
    },
    addNewResponse: function() {
      var responseModal;
      responseModal = newResponseModal({
        fieldable: this.fieldable,
        responseableGID: this.datableGID,
        response: new Skylark.App.Model.Response(),
        editing: true,
        disappearedFieldIds: this.fieldable.getDisappearedFieldIdsOnInit()
      });
      return responseModal.$on('newResponseAdded', () => {
        return this.refreshData();
      });
    },
    displayResponseIfNeed: function(event, row, child) {
      var record_index, responseModal;
      if (event.target.closest('.checkbox-cell') || event.target.closest('.attachment-item')) {
        return;
      }
      record_index = _.findIndex(this.records, function(record) {
        return record.id === row.id;
      });
      if (record_index === -1) {
        return;
      }
      this.$refs.bodyTable.focusOnRow(row);
      // open response display modal
      responseModal = newResponseModal({
        fieldable: this.fieldable,
        responseableGID: this.datableGID,
        response: this.records[record_index],
        total_count: this.records.length,
        current_index: record_index + 1,
        hasPrevResponse: this.$refs.paginator.hasPrevPage || (record_index !== 0),
        hasNextResponse: this.$refs.paginator.hasNextPage || (record_index + 1) !== this.records.length,
        disappearedFieldIds: this.fieldable.getDisappearedFieldIdsOnInit()
      });
      responseModal.$on('requestPreview', this._displayRecordByIndex);
      responseModal.$on('requestRemove', this._removeRecord);
      return responseModal.$on('responseChange', this.updateRecord);
    },
    saveToDataclipFunc: function() {
      if (this.dataclipFormModal == null) {
        this.dataclipFormModal = new DataclipFormModal({
          el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('dataclip_form_modal_container'),
          propsData: {
            dataclipableGID: Skylark.Libs.GlobalID.locate(this.fieldable.gid),
            resourceGID: this.datableGID
          }
        });
      }
      this.dataclipFormModal.open();
      this.dataclipFormModal.setConditions(this.__generateQueryParams());
      return this.dataclipFormModal.setFieldIds(_.pluck(this.filterFields, 'id'));
    },
    openResponseSearchSettingModal: function() {
      if (this.responsesSearchSettingModal == null) {
        this.responsesSearchSettingModal = new ResponsesSearchSettingModal({
          el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('responses_search_modal_container'),
          propsData: {
            dataclipableGID: Skylark.Libs.GlobalID.locate(this.fieldable.gid),
            searchSettings: this.fieldable.settings.responses_search_settings,
            fields: this.fieldable.fields
          }
        });
      }
      return this.responsesSearchSettingModal.open();
    },
    openResponseImportModal: function() {
      return new ImportRecordsModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('response_import_modal_container')
      });
    },
    exportOptionValueChangedFunc: function(vm, option) {
      return this._toggleGroupOptionsValue(option);
    },
    downloadAttachmentOptionValueChangedFunc: function(vm, option) {
      return this._toggleGroupOptionsValue(option);
    },
    closeExportPopover: function() {
      return this.$refs.exportPopover.close();
    },
    closeBatchRemoveResponsePopover: function() {
      return this.$refs.batchRemoveResponsePopover.close();
    },
    closeDownloadAttachmentPopover: function() {
      return this.$refs.downloadAttachmentPopover.close();
    },
    ensureExport: function() {
      var export_options, field_export_option, field_op, record_export_option, record_op, ref;
      this.closeExportPopover();
      if (this._exportRequesting) {
        return;
      }
      this._exportRequesting = true;
      record_op = this.$refs.recordGroupedOptionsRef.getSelectedOptions()[0];
      record_export_option = record_op.id === 'filtered' ? {
        query: _.clone(this.searchParams.query)
      } : {};
      field_op = ((ref = this.$refs.fieldGroupedOptionsRef) != null ? ref.getSelectedOptions()[0] : void 0) || {};
      field_export_option = {
        field_ids: _.pluck((field_op.id === 'filtered' ? this.filterFields : this.fields), 'id')
      };
      export_options = _.extend({}, record_export_option, field_export_option);
      return Skylark.Libs.Ajax.get(`${this.datableUrl}/responses/export?enhanced=1`, {
        data: export_options,
        responseType: 'script',
        complete: () => {
          return this._exportRequesting = false;
        }
      });
    },
    ensureDownloadAttachment: function() {
      var option, params;
      this.closeDownloadAttachmentPopover();
      option = this.$refs.recordDownloadAttachmentGroupedOptionsRef.getSelectedOptions()[0];
      params = {
        download_type: option.id === 'all' ? 'full' : '',
        response_ids: _.map(this.selectedRows, function(row) {
          return row.id;
        })
      };
      return Skylark.Libs.Ajax.post(`${this.datableUrl}/download_attachments`, {
        contentType: 'application/json; charset=utf-8',
        data: params,
        success: () => {
          return newAlertify('已成功添加下载附件任务', {
            type: 'success'
          });
        },
        error: function(xhr, status, errors) {
          return newAlertify('添加下载附件任务失败', {
            type: 'error'
          });
        }
      });
    },
    selectedRowsChangedFunc: function(rows) {
      return this.selectedRows = _.filter(rows, function(row) {
        return row.id;
      });
    },
    batchRemoveResponse: function() {
      this.closeBatchRemoveResponsePopover();
      return newConfirm({
        title: "确认删除选中的填写记录?",
        message: "删除操作不可撤销，请确认操作。",
        confirmButtonText: '删除',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return this._removeRecords();
      });
    },
    _toggleGroupOptionsValue: function(option) {
      if (!option._selected) {
        return option._selected = true;
      }
    },
    _removeRecords: function() {
      var data, ids, record_op, url;
      record_op = this.$refs.deleteRecordOptionsRef.getSelectedOptions()[0];
      data = {};
      url = `${this.datableUrl}/responses/batch_destroy`;
      if (record_op.id === 'all') {
        data = {
          _destroy_all: true
        };
      } else {
        ids = _.reduce(this.selectedRows, function(acc, row) {
          if (row.id) {
            if (acc) {
              acc = `${acc}&ids[]=${row.id}`;
            } else {
              acc = `${acc}?ids[]=${row.id}`;
            }
          }
          return acc;
        }, '');
        url = `${url}${ids}`;
      }
      return Skylark.Libs.Ajax.delete(url, {
        contentType: 'application/json, text/javascript',
        data: data,
        success: () => {
          newAlertify("删除成功");
          this.$refs.paginator.go();
          return this.$refs.bodyTable.resetAllSelected();
        },
        error: function() {
          return newAlertify("删除失败");
        }
      });
    },
    _removeRecord: function(index, responseModal) {
      var record;
      record = this.records[index];
      return Skylark.Libs.Ajax.delete(`${this.datableUrl}/responses/${record.id}.json`, {
        success: () => {
          this.records.splice(index, 1);
          this.recordRows.splice(index, 1);
          newAlertify("删除成功");
          if (index >= this.records.length && this.records.length) {
            this.$refs.bodyTable.focusOnRow(_.last(this.recordRows));
            return responseModal.resetOptions({
              response: _.last(this.records),
              total_count: this.records.length,
              current_index: this.records.length
            });
          } else if (this.records.length) {
            this.$refs.bodyTable.focusOnRow(this.recordRows[index]);
            return responseModal.resetOptions({
              response: this.records[index],
              total_count: this.records.length,
              current_index: index + 1
            });
          } else {
            responseModal.close();
            if (this.$refs.paginator.hasPrevPage) {
              return this.$refs.paginator.goPrevious();
            } else {
              // 到下一页, 当前页数据已删完，下一页被顶到当前页
              // 重取页面数据
              return this.$refs.paginator.go();
            }
          }
        },
        error: function() {
          return newAlertify("删除失败");
        }
      });
    },
    // TODO: 优化该函数，总感觉哪里有点鸡肋，怪怪得感觉
    _displayRecordByIndex: function(index, responseModal) {
      if (index >= this.records.length && this.$refs.paginator.hasNextPage) {
        this.$refs.paginator.goNext();
        return this.$once('recordsChanged', () => {
          this.$refs.bodyTable.focusOnRow(_.first(this.recordRows));
          return responseModal.resetOptions({
            response: _.first(this.records),
            total_count: this.records.length,
            current_index: 1,
            hasNextResponse: this.$refs.paginator.hasNextPage || this.records.length !== 1
          });
        });
      } else if (index < 0 && this.$refs.paginator.hasPrevPage) {
        this.$refs.paginator.goPrevious();
        return this.$once('recordsChanged', () => {
          this.$refs.bodyTable.focusOnRow(_.last(this.recordRows));
          return responseModal.resetOptions({
            response: _.last(this.records),
            total_count: this.records.length,
            current_index: this.records.length,
            hasPrevResponse: this.$refs.paginator.hasPrevPage || this.records.length !== 1
          });
        });
      } else {
        this.$refs.bodyTable.focusOnRow(this.recordRows[index]);
        return responseModal.resetOptions({
          response: this.records[index],
          current_index: index + 1,
          hasPrevResponse: this.$refs.paginator.hasPrevPage || index !== 0,
          hasNextResponse: this.$refs.paginator.hasNextPage || (index + 1) !== this.records.length
        });
      }
    },
    _formatRecords: function(records) {
      return _.map(records, function(record) {
        return new Skylark.App.Model.Response(record);
      });
    },
    _addSpecialFields: function(receivier, hidden_ids) {
      return addResponseSpecialFields(receivier, hidden_ids);
    },
    __parseSpecialCells: function(field, record, grouped_entries, rowspan, receivier) {
      switch (field.id) {
        // created_at field
        case -1:
          if (record.created_at) {
            return receivier.entries = [
              {
                field_id: -1,
                value: record.created_at
              }
            ];
          }
          break;
        case -3:
          return receivier.entries = [
            {
              field_id: -3,
              value: _.pluck(record.organizations,
            'name').join(', '),
              organizations: record.organizations
            }
          ];
        // fieldable user(author)
        case -2:
          if (record.user) {
            return receivier.entries = [
              {
                field_id: -2,
                value: record.user.name,
                user: record.user
              }
            ];
          }
          break;
        case -18:
          if (record.user) {
            return receivier.entries = [
              {
                field_id: -18,
                value: record.user.identifier
              }
            ];
          }
          break;
        case -20:
          if (record.user) {
            return receivier.entries = [
              {
                field_id: -20,
                value: record.user.phone
              }
            ];
          }
          break;
        default:
          return this.__parseNormalCells(field, record, grouped_entries, rowspan, receivier);
      }
    }
  }
});
